module.exports = __webpack_public_path__ + "static/media/plus-icon-41a152.bf6b00ea.svg";